import React, { useState } from 'react';
import { Select, Typography } from 'antd';
import { diffDrafts, diffIsEmpty } from '../../utils/regulatoryAdminModel';
import { formatDdMmYyyy } from '../../utils/formatDdMmYyyy';

const { Text } = Typography;

const Lines = ({ title, d }) => {
    if (!d || (d.added.length === 0 && d.removed.length === 0)) return null;
    return (
        <div style={{ marginTop: 8 }}>
            <Text strong>{title}</Text>
            {d.removed.map((l) => <div key={`r-${l}`} data-testid="diff-removed" style={{ color: 'var(--color-danger-fg)' }}>- {l}</div>)}
            {d.added.map((l) => <div key={`a-${l}`} data-testid="diff-added" style={{ color: 'var(--color-ok-fg)' }}>+ {l}</div>)}
        </div>
    );
};

/** Compares two approved versions of one document. `versions` are the approved enrichments, oldest first. */
const RegulationVersionDiff = ({ versions }) => {
    const [fromIdx, setFromIdx] = useState(Math.max(0, versions.length - 2));
    const [toIdx, setToIdx] = useState(versions.length - 1);
    if (versions.length < 2) return null;
    const opts = versions.map((v, i) => ({ value: i, label: `Version ${i + 1} (${formatDdMmYyyy(v.reviewedAt || v.createdAt)})` }));
    const d = diffDrafts(versions[fromIdx]?.draft, versions[toIdx]?.draft);
    return (
        <div style={{ marginTop: 16 }} data-testid="version-diff">
            <Text strong>Compare approved versions</Text>
            <div style={{ margin: '4px 0' }}>
                <Select aria-label="Compare from" style={{ width: 220 }} value={fromIdx} onChange={setFromIdx} options={opts} />
                {' '}
                <Select aria-label="Compare to" style={{ width: 220 }} value={toIdx} onChange={setToIdx} options={opts} />
            </div>
            {fromIdx === toIdx || diffIsEmpty(d) ? (
                <Text type="secondary">{fromIdx === toIdx ? 'Choose two different versions.' : 'No differences in summary, obligations or mappings.'}</Text>
            ) : (
                <>
                    <Lines title="Summary" d={d.summary} />
                    {d.applicability && <div style={{ marginTop: 8 }}><Text strong>Who it applies to</Text><div style={{ color: 'var(--color-danger-fg)' }}>- {d.applicability.from}</div><div style={{ color: 'var(--color-ok-fg)' }}>+ {d.applicability.to}</div></div>}
                    <Lines title="Obligations" d={d.obligations} />
                    <Lines title="Cross-mappings" d={d.crossMappings} />
                </>
            )}
        </div>
    );
};

export default RegulationVersionDiff;
